
<div class="container">
    <div class="sub-conatiner">
        <h2>Add Landing Page</h2>
        <form [formGroup]="landingpageForm">
            <div class="row">
                <div class="col-lg-6">
                    <label class="form-label">Banner Header (h1)</label>
                    <textarea class="form-control" formControlName="banner_header"></textarea>
                </div>
                <div class="col-lg-6">
                    <label class="form-label">Banner Sub Content</label>
                    <textarea class="form-control" formControlName="banner_sub_content"></textarea>
                </div>
                <div class="col-lg-3 mt-3">
                    <label class="form-label"><strong class="me-2">Main Color</strong>  <input type="color" formControlName="main_color" class="color"></label>
                </div>
                <div class="col-lg-3 mt-3">
                    <label class="form-label"><strong class="me-2">Sub Color</strong>  <input type="color" formControlName="sub_color" class="color"></label>
                </div>
                <div class="col-lg-3 mt-3">
                    <label class="form-label"><strong class="me-2">CTA Button One</strong> <input type="checkbox" formControlName="cta_button_one"></label>
                </div>
                <div class="col-lg-3 mt-3">
                    <label class="form-label"><strong class="me-2">CTA Button Two</strong> <input type="checkbox" formControlName="cta_button_two"></label>
                </div>
                <div class="col-lg-2" *ngIf="landingpageForm.get('cta_button_one')?.value">
                    <button (click)="toggleAction()" class="toggle-btn"
                        [ngClass]="{'popup-btn': landingpageForm.get('togglecontrol')?.value}">
                        {{ landingpageForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                </div>

                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_one')?.value">
                    <label class="form-label">CTA Button Name</label>
                    <textarea type="text" class="form-control" formControlName="cta_button_name_one"></textarea>
                </div>
                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_one')?.value && landingpageForm.get('togglecontrol')?.value">
                    <label class="form-label">Lead Source Name</label>
                    <textarea type="text" class="form-control" formControlName="lead_source_name"></textarea>
                </div>
                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_one')?.value &&  !landingpageForm.get('togglecontrol')?.value">
                    <label class="form-label">CTA Button Link</label>
                    <textarea type="text" class="form-control" formControlName="cta_button_link_one"></textarea>
                </div>
                <div class="col-lg-2" *ngIf="landingpageForm.get('cta_button_two')?.value">
                    <button (click)="toggleAction1()" class="toggle-btn"
                        [ngClass]="{'popup-btn': landingpageForm.get('togglecontrol_cta_2')?.value}">
                        {{ landingpageForm.get('togglecontrol_cta_2')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                </div>
                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_two')?.value">
                    <label class="form-label">CTA Button Name</label>
                    <textarea type="text" class="form-control" formControlName="cta_button_name_two"></textarea>
                </div>
                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_two')?.value && !landingpageForm.get('togglecontrol_cta_2')?.value">
                    <label class="form-label">CTA Button Link</label>
                    <textarea type="text" class="form-control" formControlName="cta_button_link_two"></textarea>
                </div>
                <div class="col-lg-5" *ngIf="landingpageForm.get('cta_button_two')?.value && landingpageForm.get('togglecontrol_cta_2')?.value">
                    <label class="form-label">Lead Source Name</label>
                    <textarea type="text" class="form-control" formControlName="lead_source_name_cta_2"></textarea>
                </div>
            </div>
            <hr>
            <!-- Features Section with Scroll -->
            <div class="scroll-container">
                <div class="row">
                    <div class="col-lg-12">
                        <label class="form-label">Benefit Heading (h2)</label>
                        <textarea class="form-control" formControlName="feature_heading"></textarea>
                    </div>
                </div>
                <div *ngFor="let formArray of landingpageForm.get('feature')?.controls; let i = index" [formGroup]="formArray" class="feature-container">
                    <div class="row">

                        <div class="col-lg-3">
                            <label class="form-label">Benefit Sub Heading (h3)</label>
                            <textarea class="form-control" formControlName="feature_sub_heading"></textarea>
                        </div>
                        <div class="col-lg-3">
                            <label class="form-label">Benefit Description</label>
                            <textarea class="form-control" formControlName="feature_description"></textarea>
                        </div>
                        <div class="col-lg-3">
                            <label class="form-label">Choose an Icon:</label>
                            <div class="d-flex align-items-center">
                              <select class="form-control custom-select me-2" formControlName="feature_icon">
                                <option *ngFor="let icon of iconList" [value]="icon.value">
                                  {{ icon.name }}
                                </option>
                              </select>
                              <!-- Icon Preview -->
                              <i class="fa" [ngClass]="formArray.get('feature_icon')?.value" style="font-size: 24px; margin-left: 10px;"></i>
                            </div>
                          </div>
                        <div class="col-lg-2 button-container">
                            <button class="btn btn-primary" (click)="addFeature()"><i class="fa fa-plus"></i></button>
                            <button class="btn btn-danger" (click)="removeFeature(i)"><i class="fa fa-trash"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="quill-editor-wrapper">
                <label for="title">Add Feature</label>
                <quill-editor formControlName="feature_content" style="min-width: 300px; width: 100%; margin-top: 5px;"></quill-editor>
              </div>
              <hr>
            <!-- FAQ Section with Scroll -->
            <div class="scroll-container">
                <div class="row">
                    <div class="col-lg-12">
                        <label>FAQ Heading (h2)</label>
                        <textarea class="form-control" formControlName="faq_heading"></textarea>
                    </div>
                </div>
                <div *ngFor="let faqGroup of landingpageForm.get('faq')?.controls; let i = index" [formGroup]="faqGroup" class="faq-container">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Question</label>
                            <textarea type="text" class="form-control" formControlName="quetion"></textarea>
                        </div>
                        <div class="col-lg-5">
                            <label>Answer</label>
                            <textarea class="form-control" formControlName="answer"></textarea>
                        </div>
                        <div class="col-lg-2 button-container1">
                            <button class="btn btn-primary" (click)="addFaq()"><i class="fa fa-plus"></i></button>
                            <button class="btn btn-danger" (click)="removefaq(i)"><i class="fa fa-trash"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2">
                    <button (click)="toggleAction2()" class="toggle-btn"
                        [ngClass]="{'popup-btn': landingpageForm.get('togglecontrol_cta_3')?.value}">
                        {{ landingpageForm.get('togglecontrol_cta_3')?.value ? 'Set URL' : 'Set Popup' }}
                    </button>
                </div>
                <div class="col-lg-3">
                    <label class="form-label">Bottom CTA Description</label>
                    <textarea type="text" class="form-control" formControlName="bottom_cta_description"></textarea>
                </div>
                <div class="col-lg-3">
                    <label class="form-label">Bottom CTA Button Name</label>
                    <textarea type="text" class="form-control" formControlName="bottom_cta_button_name"></textarea>
                </div>

                <div class="col-lg-3" *ngIf="!landingpageForm.get('togglecontrol_cta_3')?.value">
                    <label class="form-label">Bottom CTA Button Link</label>
                    <textarea type="text" class="form-control" formControlName="bottom_cta_button_link"></textarea>
                </div>
                <div class="col-lg-3" *ngIf="landingpageForm.get('togglecontrol_cta_3')?.value">
                    <label class="form-label">Lead Source Name</label>
                    <textarea type="text" class="form-control" formControlName="lead_source_name_cta_3"></textarea>
                </div>
            </div>
            <!-- SEO Title,Description,keywords -->
            <div class="row">
                <div class="col-lg-4">
                    <label>SEO Title</label>
                    <textarea type="text" formControlName="seo_title"></textarea>
                </div>
                <div class="col-lg-4">
                    <label>SEO Description</label>
                    <textarea type="text" formControlName="seo_description"></textarea>
                </div>
                <div class="col-lg-4">
                    <label>SEO URL(Use hyphens (-) instead)</label>
                    <textarea type="text" formControlName="seo_url_name" maxlength="60"></textarea>
                </div>
                <div class="col-lg-4">
                    <label>SEO Keywords(Press Enter)</label>
                    <textarea type="text" formControlName="keyword" (keyup.enter)="concateKeyword()"></textarea>
                </div>
            </div>
            <div class="chips-container">
                <span *ngFor="let keyword of keyword; let i = index" class="chip">
                  {{ keyword }}
                  <span class="close-btn" (click)="removeKeyword(i)">&times;</span>
                </span>
            </div>
        </form>
    </div>
    <div class="popup-footer">
        <button class="cancel-btn" (click)="close()" >Cancel</button>
        <button class="save-btn" (click)="save()">Save</button>
    </div>
</div>
